import { render } from "./SlaContent.vue?vue&type=template&id=5ca64113"
import script from "./SlaContent.vue?vue&type=script&lang=js"
export * from "./SlaContent.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__